<app-title-component [data]="{name : 'Collaborateur : '+currentCollaborateur().name , back : true, path : 'collaborateurs'}"></app-title-component>

<mat-card class="loading-table-container">
  @if (loading) {
    <div class="loading-table-shade">
      <mat-spinner diameter="70" color="primary"></mat-spinner>
    </div>
  }
  <mat-card-content>

    <mat-tab-group id="tabGroup" #tabGroup (selectedTabChange)="onTabChange($event)"  mat-stretch-tabs="false" mat-align-tabs="start">
      <!---->
      <mat-tab label="Compagnies" #comp>
        <div class="d-flex align-items-center justify-content-end p-3 border-bottom">
          <app-search-bar-component (searchBarValue)="applyFilter($event)"  appearance="outline" [width]="25"></app-search-bar-component>
        </div>
        @if (showTabs().comp) {
          <div class="mat-table-container ">
            <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">

              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
                <td mat-cell *matCellDef="let row"  data-label="ID"> {{row.compagnie_id}} </td>
              </ng-container>


              <ng-container matColumnDef="logo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Logo </th>
                <td mat-cell *matCellDef="let row"  data-label="Logo">
                  <div class="logo-container">
                    <img class="avatar-img" [src]="API_STORAGE + row.compagnie_logo" alt="logo" (error)="$event.target.style.display='none'">
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="code_partenaire">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Code </th>
                <td mat-cell *matCellDef="let row"  data-label="Code"> {{row.code_partenaire??'N/A'}} </td>
              </ng-container>


              <ng-container matColumnDef="compagnie">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Compagnie </th>
                <td mat-cell *matCellDef="let row"  data-label="Compagnie"> {{row.compagnie_name}} </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Etat </th>
                <td mat-cell *matCellDef="let row"  data-label="Etat">
                    @if(row.join){<span class="state_actif">Associe</span>}
                    @else {<span class="state_inactif">Dissocie</span>}
                </td>
              </ng-container>

              <!-- Action -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef sticky="true" class="table-row-actions"> Actions </th>
                 <td mat-cell *matCellDef="let row" class="table-row-actions">
                    <button matButton [matTooltip]="row.join?'Dissocier':'Associer'" (click)="checkCode(row)" class="bg-mat-cyan">Modifier</button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue}}"</td>
              </tr>
                  </table>
      </div>          </div>

        }
      </mat-tab>

      <!---->
      <mat-tab label="Documents" #doc>
        <div class="d-flex align-items-center justify-content-end p-3 border-bottom">
          <app-search-bar-component (searchBarValue)="applyFilter($event)" [width]="25" appearance="outline"></app-search-bar-component>
        </div>
        @if (showTabs().doc) {
          <div class="mat-table-container">
            <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">

              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
                <td mat-cell *matCellDef="let row"  data-label="ID"> {{row.id}} </td>
              </ng-container>


              <ng-container matColumnDef="compagnie">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Compagnie </th>
                <td mat-cell *matCellDef="let row"  data-label="Compagnie"> {{row.compagnie_name}} </td>
              </ng-container>


              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Type </th>
                <td mat-cell *matCellDef="let row"  data-label="Type"> {{row.type}} </td>
              </ng-container>

              <ng-container matColumnDef="attestation_range">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Plage attestation </th>
                <td mat-cell *matCellDef="let row"  data-label="Plage attestation"> {{attestationFormat(row.attestation_range, row.code, row.type)}}</td>
              </ng-container>

              <ng-container matColumnDef="carte_rose_range">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Plage carte rose </th>
                <td mat-cell *matCellDef="let row"  data-label="Plage carte rose"> {{row.carte_rose_range | rangePipe}} </td>
              </ng-container>

              <ng-container matColumnDef="qte">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Quantite </th>
                <td mat-cell *matCellDef="let row"  data-label="Quantite"> {{row.qte}} </td>
              </ng-container>

              <ng-container matColumnDef="reste">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Reste </th>
                <td mat-cell *matCellDef="let row"  data-label="Reste">
                  <span [class]="setColorQteState(row.qte, row.reste)">{{row.reste}}</span>
                </td>
              </ng-container>

              <!-- Action -->

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue}}"</td>
              </tr>
                  </table>
      </div>          </div>
        }

      </mat-tab>

      <!--
      <mat-tab label="Sites" #site>
        <div class="searchBar">
          <app-search-bar-component (searchBarValue)="applyFilter($event)" class="app-search-bar-component" [width]="100" appearance="outline"></app-search-bar-component>
          <button matTooltip="Nouveau site" (click)="openAddSiteModal()" mat-flat-button color="primary"
      <button class="btn-add px-4 py-4 fw-semibold">
            <mat-icon>add</mat-icon>
            <span>Ajouter</span>
          </button>
        </div>
        @if (showTabs().site) {

          <div class="mat-table-container">
           <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">

              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
                <td mat-cell *matCellDef="let row"  data-label="ID"> {{row.id}} </td>
              </ng-container>


              <ng-container matColumnDef="collaborateur_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Collaborateur </th>
                <td mat-cell *matCellDef="let row"  data-label="Collaborateur"> {{row.collaborateur_name }} </td>
              </ng-container>



              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Bureaux </th>
                <td mat-cell *matCellDef="let row"  data-label="Bureaux"> {{row.name | uppercase }} </td>
              </ng-container>


              <ng-container matColumnDef="owner">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Proprietaire </th>
                <td mat-cell *matCellDef="let row"  data-label="Proprietaire"> {{row.owner | uppercase }} </td>
              </ng-container>


              <ng-container matColumnDef="adresse">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Adresse </th>
                <td mat-cell *matCellDef="let row"  data-label="Adresse"> {{row.adresse | uppercase }} </td>
              </ng-container>


              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Etat </th>
                <td mat-cell *matCellDef="let row"  data-label="Etat">
                    @if(row.disable){<span class="state_inactif">Desactive</span>}
                    @else {<span class="state_actif">Active</span>}
                </td>
              </ng-container>


              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef sticky="true" class="table-row-actions"> Actions </th>
                 <td mat-cell *matCellDef="let row" class="table-row-actions">
                  <button (click)="onChangeSiteState(row);$event.stopPropagation()" [matTooltip]="row.disable?'Debloquer':'Bloquer'" matButton="" color="primary" type="button">
                    @if (row.disable) {<mat-icon style="color: rgb(0, 95, 0);">frame_person</mat-icon>}
                    @else {<mat-icon style="color: rgb(194, 126, 0);">frame_person_off</mat-icon>}

                  </button>
                  <button matTooltip="modifier" (click)="openUpdateSite(row); $event.stopPropagation()" matButton="" color="primary" type="button">
                    <mat-icon class="text-muted-icon">edit</mat-icon>
                  </button>
                  <button matTooltip="supprimer" (click)="confirmDeleteSite(row); $event.stopPropagation()" matButton="" color="warn" type="button">
                     <mat-icon>delete_outline</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goToSiteDetails(row)" matTooltip="{{ 'acceder au bureau : '+row.name  }}"></tr>


              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue}}"</td>
              </tr>
                  </table>
      </div>          </div>
        }
      </mat-tab>

      <mat-tab label="Utilisateurs" #user>
          <app-search-bar-component (searchBarValue)="applyFilter($event)" class="app-search-bar-component"  appearance="outline"></app-search-bar-component>
        @if (showTabs().user) {

          <div class="mat-table-container">
                     <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
              <td mat-cell *matCellDef="let row"  data-label="ID"> {{row.id}} </td>
            </ng-container>


            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Nom & Prenom </th>
              <td mat-cell *matCellDef="let row"  data-label="Nom & Prenom "> {{row.name | uppercase }} </td>
            </ng-container>



            <ng-container matColumnDef="profil">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Profil </th>
              <td mat-cell *matCellDef="let row"  data-label="Profil"> {{row.profil_name | uppercase }} </td>
            </ng-container>


            <ng-container matColumnDef="gender">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Genre </th>
              <td mat-cell *matCellDef="let row"  data-label="Genre"> {{row.gender | uppercase }} </td>
            </ng-container>


            <ng-container matColumnDef="adresse">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Adresse </th>
              <td mat-cell *matCellDef="let row"  data-label="Adresse"> {{row.adresse | uppercase }} </td>
            </ng-container>


            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Etat </th>
              <td mat-cell *matCellDef="let row"  data-label="Etat">
                  @if(row.disable){<span class="state_inactif">Desactive</span>}
                  @else {<span class="state_actif">Active</span>}
              </td>
            </ng-container>



            <ng-container matColumnDef="site_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Bureau </th>
                <td mat-cell *matCellDef="let row"  data-label="Bureau"> {{row.site_name | uppercase }} </td>
            </ng-container>


            <ng-container matColumnDef="collaborateur_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Collaborateur </th>
                <td mat-cell *matCellDef="let row"  data-label="Collaborateur"> {{row.collaborateur_name | uppercase }} </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue}}"</td>
            </tr>
                </table>
      </div>          </div>
        }
      </mat-tab>-->

    </mat-tab-group>
  </mat-card-content>
  <mat-card-footer>
      <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
  </mat-card-footer>
</mat-card>



